<template>
    <compensating-factors-table></compensating-factors-table>
</template>

<script>
import CompensatingFactorsTable from '../components/Results/CompensatingFactorsTable'
import { mapGetters, mapActions, mapMutations } from 'vuex';

export default {
    components: {
        CompensatingFactorsTable
    },
    computed: {
        ...mapGetters(["getScenario"]),
    },
    methods: {
        ...mapActions(["fetchScenario"]),
        ...mapMutations(["setSelectedLoanId"])
    },
    mounted() {
        if (this.getScenario.id === null) {
            this.setSelectedLoanId(this.$route.params.id);
            this.fetchScenario({ scenario: "haloScenario" });
        }
    },
}
</script>